export const PDP_URL_PREFIX = 'https://appsumo.com/products/';

export const SUBSCRIBE_URL = '/accounts/signup/email-subscribe/';
export const WAITLIST_URL = '/deal/waitlist-signup/';

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i; // NOSONAR

export const APPSUMO_PLUS_DEAL_ID = 1735;
export const DEFAULT_PLUS_DISCOUNT_PERCENTAGE = 10;

export const NEXT_ONE_TAP_EXPERIMENT_NAME = 'indexable-google-one-tap';
export const ASKSUMO_CLEANUP_EXPERIMENT_NAME = 'asksumo-v2';
export const ASKSUMO_BROWSE_EXPERIMENT_NAME = 'asksumo-browse';
export const SWAG_PROMO_EXPERIMENT_NAME = 'swag-promo';
export const PROJECT_FOMO_EXPERIMENT_NAME = 'nav-project-fomo-v2';
export const STRIPE_LAYOUT_EXPERIMENT_NAME = 'stripe-layout';
export const CART_SHELF_EXPERIMENT_NAME = 'next-cart-shelf';
export const FACEBOOK_LOGIN_EXPERIMENT_NAME = 'facebook-login';
export const NEXT_PDP_EXPERIMENT_NAME = 'next-pdp';
export const NEXT_QUESTION_REVIEW_EXPERIMENT_NAME = 'next-qnr';
export const LOAD_PRIVY_NO_UTM_PARAM = 'privy-no-utm-param';
export const MOBILE_PRIVY_POPUP = 'mobile-privy-popup';
export const USE_NEW_404_PAGE = 'use-new-404-page';
export const KLARNA_MESSAGE_POSITION_EXPERIMENT_NAME =
  'klarna-message-position';
export const AGGREGATE_PAGE_EXPERIMENT_NAME = 'next-aggregate-qr-page';
export const NAV_SIGN_UP_EXPERIMENT_NAME = 'nav-sign-up';

export const SWAG_PROMO_CAMPAIGN_NAME = 'sd-swag-promo-2023';

// Social media share URLs
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer/sharer.php?';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet?';
export const LINKEDIN_SHARE_URL =
  'https://www.linkedin.com/shareArticle?mini=true&';
export const PLAN_TYPES_SUFFIX = ['annual', 'lifetime'];

export const PDP_REGEX = /\/products\/[a-zA-Z0-9_-]+\/$/;
export const IS_INDEXABLE_PAGE_REGEX =
  /\/products\/[a-zA-Z0-9_-]+\/(reviews|questions)\/[a-zA-Z0-9_-]+\/$/;
export const isPDP = (url: string) => PDP_REGEX.test(url);
export const isIndexablePage = (url: string) =>
  IS_INDEXABLE_PAGE_REGEX.test(url);
export enum DEAL_STAGE {
  INACTIVE = 'inactive',
  EARLY_ACCESS = 'early access',
  GENERAL_ACCESS = 'general access',
  LAST_CALL = 'last call',
}
